// ClassAssembly4C
import React from 'react';
import ClassAssembly4C  from 'views/ClassAssembly4C';

const ClassAssembly4CPage = () => {
    return <ClassAssembly4C />;
  };
  
  export default ClassAssembly4CPage;